/*
  YUPA ADD-ONS - eigen bestand, hoort niet bij het thema Ivory.
  Zie snippets/yupa-addons.liquid.

  Werking: luistert in de capture-fase naar het submit van het productformulier.
  Is er minstens een add-on aangevinkt, dan neemt dit script die ene submit over
  en stuurt hoofdproduct + add-ons in EEN /cart/add.js-aanroep. Daarna dezelfde
  events als het thema (variant:added, cart:updated, cart:refresh,
  cart-notification:show), zodat de cart drawer zich normaal gedraagt.
  Niets aangevinkt = dit script doet niets en het thema werkt zoals altijd.
*/
(function () {
  if (window.yupaAddonsLoaded) return;
  window.yupaAddonsLoaded = true;

  function checkedAddons(formId) {
    var wrapper = document.querySelector('[data-yupa-addons][data-form-id="' + formId + '"]');
    if (!wrapper) return [];
    return Array.prototype.slice.call(wrapper.querySelectorAll('[data-yupa-addon]:checked')).filter(function (input) {
      var item = input.closest('.yupa-addons__item');
      return !(item && item.hidden);
    });
  }

  // Upsells die alleen bij bepaalde varianten horen (bijv. alleen bij een pakket):
  // tonen of verbergen bij het wisselen van variant, verborgen vinkjes gaan uit.
  document.addEventListener('variant:changed', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var formId = form.getAttribute('id');
    var variant = event.detail && event.detail.variant;
    if (!formId) return;

    var wrapper = document.querySelector('[data-yupa-addons][data-form-id="' + formId + '"]');
    if (!wrapper) return;

    var key = variant && variant.id ? ',' + variant.id + ',' : null;
    Array.prototype.forEach.call(wrapper.querySelectorAll('[data-yupa-upsell]'), function (item) {
      var showFor = item.getAttribute('data-show-for') || '';
      var show = key !== null && showFor.indexOf(key) !== -1;
      item.hidden = !show;
      if (!show) {
        var checkbox = item.querySelector('[data-yupa-addon]');
        if (checkbox) checkbox.checked = false;
      }
    });

    var anyVisible = Array.prototype.some.call(wrapper.querySelectorAll('.yupa-addons__item'), function (item) {
      return !item.hidden;
    });
    wrapper.hidden = !anyVisible;
  });

  function buildItems(form, addonInputs) {
    var data = new FormData(form);
    var main = { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) };
    var properties = {};
    var hasProperties = false;

    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string' && value !== '') {
        properties[match[1]] = value;
        hasProperties = true;
      }
    });

    if (hasProperties) main.properties = properties;
    if (data.get('selling_plan')) main.selling_plan = Number(data.get('selling_plan'));

    var items = [main];
    addonInputs.forEach(function (input) {
      items.push({ id: Number(input.value), quantity: 1 });
    });
    return items;
  }

  function setBusy(form, busy) {
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.type !== 'submit') return;
      if (busy) {
        el.setAttribute('disabled', 'disabled');
        el.setAttribute('aria-busy', 'true');
      } else {
        el.removeAttribute('disabled');
        el.removeAttribute('aria-busy');
      }
    });
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form || form.getAttribute('is') !== 'product-form') return;

    // Let op: form.id geeft hier het verborgen veld name="id" terug, niet het formulier-id.
    var formId = form.getAttribute('id');
    if (!formId) return;

    var addonInputs = checkedAddons(formId);
    if (addonInputs.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var routes = window.themeVariables.routes;
    var settings = window.themeVariables.settings;

    setBusy(form, true);

    var response;
    var responseJson = {};
    try {
      response = await fetch(routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: buildItems(form, addonInputs), sections: 'mini-cart' })
      });
      responseJson = await response.json();
    } catch (error) {
      response = { ok: false };
    }

    setBusy(form, false);

    if (response.ok) {
      addonInputs.forEach(function (input) { input.checked = false; });

      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = Shopify.routes.root + 'cart';
        return;
      }

      form.dispatchEvent(new CustomEvent('variant:added', {
        bubbles: true,
        detail: { variant: responseJson.items ? responseJson.items[0] : responseJson }
      }));

      fetch(routes.cartUrl + '.js').then(async function (cartResponse) {
        var cartContent = await cartResponse.json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartContent } }));
        cartContent.sections = responseJson.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cartContent, openMiniCart: settings.cartType === 'drawer' && form.closest('.drawer') === null }
        }));
      });
    } else {
      form.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    form.dispatchEvent(new CustomEvent('cart-notification:show', {
      bubbles: true,
      cancelable: true,
      detail: { status: response.ok ? 'success' : 'error', error: responseJson.description || '' }
    }));
  }, true);
})();
